import Model, { attr } from '@ember-data/model';

import { UserLevel } from 'webapp/enums/enums';

import type { Metadata } from 'webapp/models-custom/user';

export default class UserRecord extends Model {
	@attr('boolean', { defaultValue: true }) activated!: boolean;
	@attr('boolean') isVerified!: boolean;
	@attr('string', { defaultValue: '' }) name!: string;
	@attr('string', { defaultValue: '' }) email!: string;
	@attr('string') avatar!: string;
	@attr('number') created!: number;
	@attr('number') lastSeen!: number;
	@attr('number') lastLoginMobile!: number;
	@attr('number', { defaultValue: UserLevel.USER }) level!: UserLevel;
	@attr('string') timezone!: string;
	@attr('boolean', { defaultValue: false }) isRestricted!: boolean; // true when agency admin in client's space
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	notifications!: number[];
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	spaces!: number[];
	@attr('boolean', { defaultValue: false }) connectedSlack!: boolean;
	@attr('number') resendInvitationMailCount!: number;
	@attr('object', {
		defaultValue() {
			return {
				title: null,
				department: null,
				role: null,
				seniority: null,
				onboardingObjectives: null, // hidden for now, hidden-onboardingObjectives
				sourcesSelection: null,
				personaType: null,
			};
		},
	})
	metadata!: Metadata;
	@attr('boolean', { defaultValue: false }) isParentUser!: boolean;
}
